import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, ViewChild, OnDestroy, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Logo } from '../../../components/logo/logo';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Auth } from '../../../services/auth';
import { ThemeService, ThemeMode } from '../../../services/theme.service';
import { ServersSessionsService } from '../../../services/servers-sessions.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MultipleAccountsComponent } from '../modal/multiple-accounts/multiple-accounts';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatSnackBarModule,
    CommonModule,
    Logo,
    RouterLink,
    TranslatePipe
  ],
  templateUrl: './login.html',
  styleUrl: './login.css'
})
export class Login implements OnDestroy {

  private _auth = inject(Auth);
  private _sessions_service = inject(ServersSessionsService);
  private _router = inject(Router);
  private _activivatedRoute = inject(ActivatedRoute);
  private _themeService = inject(ThemeService);
  private _dialog = inject(MatDialog);
  private _snackBar = inject(MatSnackBar);
  email_precadastrado: string = '';
  mensagem: string = '';
  private _originalTheme: ThemeMode = 'system';
  redir: string = '';
  public perfil: string = 'aluno';

  @ViewChild('password') password_input!: ElementRef<HTMLInputElement>;

  loading: boolean = false;
  hidePassword: boolean = false;
  showLoginForm: boolean = false;
  showMsg = signal(false);

  formGroup = new FormGroup({

    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  ngOnInit() {

    if(this._auth.getUrlRedirect() && this._auth.getUrlRedirect().startsWith('/cadastro-curso')){

      this.showMsg.set(true);
    }else{

      this.showMsg.set(false);
    }

    // Store original theme and force light theme
    this._originalTheme = this._themeService.themeMode();
    this._themeService.setTheme('light');

    this._auth.getCsrf().subscribe();
    this.email_precadastrado = this._activivatedRoute.snapshot.queryParams['email'];
    if (this.email_precadastrado) {
      this.showLoginForm = true;
    }
    this.mensagem = this._activivatedRoute.snapshot.queryParams['msg'];

    if (this._activivatedRoute.snapshot.queryParams['perfil'] && this._activivatedRoute.snapshot.queryParams['perfil'] === 'funcionario') {
      this.perfil = 'funcionario';
      this.showLoginForm = true;
    }
  }

  ngOnDestroy() {
    // Restore original theme when leaving the page
    this._themeService.setTheme(this._originalTheme);
  }

  ngAfterViewInit(): void {

    if (this.email_precadastrado) {

      this.formGroup.get('username')?.setValue(this.email_precadastrado);
      this.formGroup.markAllAsTouched();
      this.password_input.nativeElement.focus();
    };

    this._auth.clearAuthStorage();

    if (this._auth.consumeSessionExpired()) {

      this._snackBar.open('Sua sessão expirou. Faça login novamente.', 'OK', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });
    }
  }

  submit() {

    if (this.loading) {
      return;
    }

    this.loading = true;

    this._auth.login(this.formGroup.value).subscribe({
      next: (data: any) => {

        if (data.redirect === 'dashboard') {

          if (this._auth.getUrlRedirect()) {

            // console.log(this._auth.getUrlRedirect());
            //this._router.navigateByUrl(this._auth.getUrlRedirect());            
            this._sessions_service.redirectExternal(this._auth.getUrlRedirect());
          } else {

            this._sessions_service.redirectExternal();
            //this._router.navigate([data.redirect]);
          }

        } else {

          this._router.navigate([data.redirect], { queryParams: { email: this.formGroup.value.username! } });
        }
      },
      error: (data) => {

        this.loading = false;
        console.log(data);

        if (data.error?.code === 'MULTIPLE_ACCOUNTS') {

          this._dialog.open(MultipleAccountsComponent, {
            data: { message: data.error.error }
          });

        } else {

          this.formGroup.setErrors({
            invalidCredentials: true
          });
        }
      }
    });
  }

}
